import { render } from "./LocationSummary.vue?vue&type=template&id=64afac75"
import script from "./LocationSummary.vue?vue&type=script&lang=js"
export * from "./LocationSummary.vue?vue&type=script&lang=js"

import "./LocationSummary.vue?vue&type=style&index=0&id=64afac75&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__